import { Box, Card, IconTextButton, Typography } from '@scope/scope-one-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'shared/hooks';
import { COLORS } from '@scope/scope-one-ui/theme';
import ArrowUpIcon from '../../../assets/icons/arrow-up-right.svg';
import { ESGScoresOverTime } from './ESGScoresOverTime/ESGScoresOverTime';
import ScoreBreakdownWidget from './ScoreBreakdownWidget/ScoreBreakdownWidget';
import { ESGEventsSection } from './ESGEventsSection';
import { ESGDailyScoreSection } from './ESGDailyScoreSection';
import { PeerGroupComparison } from './PeerGroupComparison';
import { MoreInfoModal } from './MoreInfoModal';

export const ESGSentiment = () => {
  const { t } = useTranslation();
  const moreInfoModal = useModal();

  return (
    <Box display="flex" flexDirection="column" gridGap={4}>
      <Card>
        <Box p={2} display="flex" justifyContent="space-between">
          <Typography color={COLORS.typography.label} variant="h1">
            {t('ESG Sentiment')}
          </Typography>
          <IconTextButton icon={<ArrowUpIcon />} onClick={moreInfoModal.show}>
            {t('More info')}
          </IconTextButton>
        </Box>
        <MoreInfoModal open={moreInfoModal.isOpen} onClose={moreInfoModal.close} />
      </Card>
      <ESGDailyScoreSection />
      <ScoreBreakdownWidget />
      <ESGScoresOverTime />
      <Box px={2}>
        <Typography variant="h1">{t('ESG Events talked about by Influencers')}</Typography>
      </Box>
      <ESGEventsSection />
      <PeerGroupComparison />
    </Box>
  );
};
